<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('brand/fetchBrand')
  }
}
</script>

<style>
#app {
  height: 100%;
}
</style>
